import { ref } from 'vue'

let idCounter: number = 0
export const searchBarExculseTargetIds: string[] = [
  'searchBar-project-list',
  'searchBar-project-search'
]

/**
 * @param prefix that bind before unique number
 * @param addToExculseTargetIds if true, add this id to exculseTargetIds
 * @returns unique id
 */
export function useId(prefix: string = 'id', addToExculseTargetIds: boolean = false) {
  const id = ref(`${prefix}-${idCounter++}`)
  if (addToExculseTargetIds) {
    searchBarExculseTargetIds.push(id.value)
  }
  return id
}
